import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { StoreAuthService } from '@app/core/auth/store-auth.service';
import { StoreUserService } from '@app/core/state/store-user.service';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable({
  providedIn: 'root'
})

export class CreateUserDataService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private storeAuth: StoreAuthService,
    private common: DatabaseCacheService
  ) { }

  createUserData(userDataPostBody) {

    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    headers = headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    return this.httpClient.post(`${apiConfig.uri}/licence/${sectionId}/userdata`, userDataPostBody, { headers: headers });
  }
}
